import React, { useState, useEffect, memo, useContext } from 'react';

import Button from 'b2b-ui-components-lib/lib/components/button';

import { AppContext } from 'App';

import { scrollToDiv } from 'common/utils/app.utils';

import './TopBar.scss';

const TopBar = () => {
  const { pageData } = useContext(AppContext);
  const { navs, phoneNumber } = pageData?.topBar;

  const [activeSectionId, setActiveSectionId] = useState('planSection');

  useEffect(() => {
    trackScrolling();
    return () => {
      window.removeEventListener('scroll', () => {});
    };
  }, []);

  const trackScrolling = () => {
    window.addEventListener('scroll', () => {
      for (const nav of navs) {
        const activeElem = document.querySelector(`#${nav?.section}`);
        const activeElemPosition = activeElem && activeElem.getBoundingClientRect();
        if (activeElemPosition && activeElemPosition.top > 0 && activeElemPosition.top <= 150) {
          removeActiveClass();
          if (document.querySelector(`#${nav?.section}Li`)) {
            document.querySelector(`#${nav?.section}Li`).classList.add('active');
          }
        }
      }
    });
  };

  const removeActiveClass = () => {
    for (const nav of navs) {
      if (document.querySelector('#' + nav?.section + 'Li')) {
        document.querySelector('#' + nav?.section + 'Li').classList.remove('active');
      }
    }
  };

  const handleLinkClick = (sectionId) => {
    setActiveSectionId(sectionId);
    scrollToDiv(sectionId);
  };

  const [contactScroll, setContactScroll] = useState(false);
  useEffect(() => {
    window.addEventListener('scroll', () => {
      setContactScroll(window.scrollY > 100);
      console.log(setContactScroll);
    });
  }, []);

  return (
    <div className="top_bar">
      <section className="navigation">
        <div className="container nav_wrapper">
          <ul className="nav-list">
            {navs?.map((item) => (
              <li key={item.id} id={item.id} className={activeSectionId === item.section ? 'active' : ''}>
                <a onClick={() => handleLinkClick(item.section)}>{item.name}</a>
              </li>
            ))}
          </ul>
          <div className={`other_resources ${contactScroll ? 'number_disabled' : ''}`}>
            <div className="lft-space">
              <Button buttonClass="check-btn" onClick={() => window?.open(`tel:${phoneNumber}`, '_self')}>
                <img src="https://assets.airtel.in/static-assets/acquisition/images/phone.svg" alt="Phone Number" />
                <div className="phone_no">{phoneNumber}</div>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default memo(TopBar);
